<template>
    <div>
        <div class="container mt-4 mb-4">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'federal'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2">Reglas</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!-- AREA DE ARCHIVOS -->
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5423972&fecha=29/01/2016" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> REGLAS de Operación del Fondo Metropolitano 2016 </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5387312&fecha=31/03/2015'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> REGLAS de Operación del Fondo Metropolitano 2015 </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                     <a :href="urlServe+'marco-juridico/Federal/informacion/Reglas/Reglas-de-operacion-art-3-B-LCF.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Reglas de Operación para la aplicación del Artículo 3-B de la Ley de Coordinación Fiscal </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Reglas/Integracion.pdf'" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Reglas de Integración y Operación de los Grupos Técnicos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Reglas/Validacion.pdf'" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Reglas de Validación de las Contribuciones Asignables </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <h4 class="subtitulo2 mt-5">Reglas de Operación</h4>
                    <h5 style="font-size:1rem;">Reglas de Operación del Programa Rescate de Espacios Públicos, para el ejercicio fiscal 2015 y subsecuentes</h5>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5377730&fecha=30/12/2014" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Primera Parte </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5377732&fecha=30/12/2014" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Segunda Parte </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <h5 class="mt-4" style="font-size:1rem;">Programa para el Desarrollo de Zonas Prioritarias</h5>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5377484&fecha=27/12/2014" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Acuerdo </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5387658&fecha=02/04/2015" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Acuerdo modificatorio </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5421991&fecha=31/12/2015" target="_blank"> 
                        <div class="mb-2 mt-5">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Programa de Empleo Temporal 2016 </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <h5 class="mt-4" style="font-size:1rem;">Programa Hábitat, para el ejercicio fiscal 2015 y subsecuentes</h5>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5377913&fecha=31/12/2014" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Primera Parte </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5377915&fecha=31/12/2014" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Segunda Parte </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5467896&fecha=28/12/2016" target="_blank"> 
                        <div class="mb-2 mt-5">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Programa 3x1 para Migrantes 2017 </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <!--  -->
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5421646&fecha=29/12/2015" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Programa 3x1 para Migrantes 2016 </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <!--  -->
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5467898&fecha=28/12/2016" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Programa de Atención a Jornaleros Agrícolas 2017 </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <!--  -->
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5421500&fecha=28/12/2015" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Programa de Atención a Jornaleros Agrícolas 2016 </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <!-- Area de criterios -->
                    <h6 class="subtitulo mb-2">Criterios</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!--  -->
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Criterios/criterios-LDF.pdf'" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Criterios para la elaboración y presentación homogénea de la información financiera y de los formatos a que hace referencia la Ley de Disciplina Financiera de las Entidades Federativas y los Municipios </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                     <a :href="urlServe+'marco-juridico/Federal/informacion/Criterios/criterios-DH.pdf'" target="_blank"> 
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Criterios para que los sujetos obligados garanticen condiciones de accesibilidad que permitan el ejercicio de los derechos humanos de acceso a la información y protección de datos personales a grupos vulnerables </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                                   
                </div>
                
                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes img_fija">
                        <div class="sec_imagen"> 
                            <img src="@/assets/imagenes/reglas.jpg" alt="">  
                        </div>
                    </div>
                    
                    
                </div>
            </div>
            <div class="text-aviso my-5">
                <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
            </div>
        </div>
    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
      atrasComponent  ,
      botonAtras
    }
}
</script>

<style scoped>
    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        /* line-height: 20px; */
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    .text-aviso h5 {      

        font-size: 1rem;
        font-weight: 400;
        /* line-height: 20px; */
    }
    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .resaltado-vino{
        color: #560F2C;
        font-weight: 500;
    }
    /* imagen fija */
    .img_fija{
        position: sticky !important;
        top: 7% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }
}

</style>